/**
 * POST a /api/Auth/CambiarClave. Cambia la contraseña del usuario autenticado.
 */
import axiosController from "helpers/axiosController";

const POSTCambiarClave = async (payload) => {
  try {
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/auth/cambiar_clave`,
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
      data: payload,
    };

    const response = await axiosController.request(config);

    return response.data;
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    } else if (error.request) {
      return { status: 500, message: "No se recibió respuesta del servidor" };
    } else {
      return { status: 400, message: "Error al realizar la solicitud" };
    }
  }
};

export default POSTCambiarClave;
